import en from './en';
import ch from './ch';
import Cook from "../common/cookie";
import util from "../common/util";

/**
 * 获取当前网站的语言版本
 * 顺序优先级
 * 1 看url里面是否有lang=en的字段，
 * 2 看cookie里面是否有lang字段
 */
export function language () {
    var lan = Cook.get("lang");
    var urlLan = util.getQueryString('lang');
    // 如果url里面设置了英文)
    if (urlLan == 'en') {
        return en;
    } else if (urlLan == 'ch') {
        return ch;
    }

    if (lan == null || lan == undefined) {
        Cook.set("lang", "ch", 7)
    }
    if (lan == "en") {
        return en;
    }
    return ch;
}

export function getLanguage (lan) {
    // 如果url里面设置了英文)
    if (lan == 'en') {
        return en;
    } else {
        return ch;
    }
}